import { $http } from "@/assets/js/appFunc";

export const getInitialEmailTemplate = (context, templateId) => {
    const req = {
        type: "GET",
        url: `/engine/api/getTemplateById/${templateId}`

    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                resolve(data.data);
            },
            error => {
                reject(error);
                console.log(error);
            }
        );
    });
};

export const saveInitialEmailTemplate = (context, payload) => {
    const req = {
        type: "POST",
        url: "/engine/api/saveTemplate",
        data: payload
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                resolve(data.data);
            },
            error => {
                reject(error);
                console.log(error);
            }
        );
    });
};

export const restoreDefaultEmailTemplate = (context, templateId) => {
    const req = {
        type: "POST",
        url: `/engine/api/email-template/reset/${templateId}`
    };
    return new Promise((resolve, reject) => {
        $http(req, true).then(
            data => {
                resolve(data.data);
            },
            error => {
                reject(error);
                console.log(error);
            }
        );
    });
};
